import React, { Component } from 'react';

class NotificationButton extends Component {
    constructor(props) {
        super(props);
    }

    renderBadge() {
        const { counter } = this.props;
        if (counter === 0) return null;
        return <span className='custom-badge'>{counter}</span>;
    }

    render() {
        const { label, icon, onClick } = this.props;
        return (
            <button className='btn' onClick={onClick}>
                <div>
                    <i className={icon} />
                    {this.renderBadge()}
                </div>
                <span className='text'>{label}</span>
            </button>
        );
    }
}

export default NotificationButton;
